import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {configureAnchors} from 'react-scrollable-anchor'
import {isMobile} from 'react-device-detect'
import cn from 'classnames'
import Rellax from 'rellax'
import withWidth from '@material-ui/core/withWidth'

import Header from './Header'
import Banner from './Banner'
import Mission from './Mission'
import Services from './Services'
import Benefits from './Benefits'
import Packs from './Packs'
import Extras from './Extras'
import Portfolio from './Portfolio'
/*import Faq from './Faq'*/
import Agency from './Agency'
import Contact from './Contact'
import PACKS from '../fixtures/packs'
import Messenger from './Messenger'

const anchorOptions = {
  offset: 1,
  scrollDuration: 1000,
  keepLastAnchorHash: false,
}

const configureParallax = () => {
  new Rellax('.Banner-Background', {
    round: true,
    vertical: true,
    speed: -8,
  })
  new Rellax('.Services-Background', {
    round: true,
    vertical: true,
    center: true,
    speed: -8,
  })
  new Rellax('.Contact-Background', {
    round: true,
    vertical: true,
    center: true,
    speed: -8,
  })
}

const sections = [
  {id: 1, name: 'isImageMessage', count: 1, label: 'Main image & key message', selected: true},
  {id: 2, name: 'isAbout', count: 1, label: 'About us', extraLabel: '/ Mission / Vision', selected: true},
  {id: 3, name: 'isServices', count: 2, label: 'Services', extraLabel: '/ Products', selected: true},
  {id: 4, name: 'isContact', count: 2, label: 'Contact us', extraLabel: '/ Messenger', selected: true},
  {id: 5, name: 'isPortfolio', count: 2, label: 'Portfolio', extraLabel: '/ Case studies'},
  {id: 6, name: 'isBenefits', count: 1, label: 'Benefits', extraLabel: '/ Why choose us'},
  {id: 7, name: 'isProcess', count: 2, label: 'Process', extraLabel: '/ How we work'},
  {id: 8, name: 'isTeam', count: 2, label: 'Team', extraLabel: '/ Location / Showroom'},
  {id: 9, name: 'isPartners', count: 2, label: 'For partners', extraLabel: '/ Suppliers'},
  {id: 10, name: 'isTestimonials', count: 1, label: 'Testimonials', extraLabel: '/ Clients'},
  {id: 11, name: 'isAction', count: 1, label: 'Call to action', extraLabel: '/ Promotion'},
  {id: 12, name: 'isBlog', count: 3, label: 'Blog', extraLabel: '/ News'},
  {id: 13, name: 'isFaq', count: 1, label: 'FAQ'},
  {id: 14, name: 'isBooking', count: 3, label: 'Booking appointment'},
  {id: 15, name: 'isOther', count: 2, label: 'Other pages'},
]

const initialState = sections.reduce((state, section) => {
  state[section.name] = Boolean(section.selected)
  return state
}, {})

class App extends Component {
  state = {...initialState, isLoaded: false}

  static propTypes = {
    width: PropTypes.string.isRequired,
  }

  componentDidMount() {
    window.addEventListener('load', this.handleLoaded)
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.width !== this.props.width && nextProps.width !== 'xs') {
      configureAnchors(anchorOptions)
    }
  }

  handleLoaded = () => {
    const {width} = this.props
    !isMobile && configureParallax()
    width !== 'xs' && configureAnchors(anchorOptions)
    document.getElementById('preloader').classList.remove('Preloader_show')
    document.body.style.overflow = 'auto'
    this.setState({isLoaded: true})
  }

  handleSectionSet = sectionName => () => {
    this.setState(state => ({
      ...state,
      [sectionName]: !state[sectionName],
    }))
  }

  render() {
    const {width} = this.props
    const {isLoaded, ...state} = this.state
    const selectedSections = Object.keys(state).filter(key => state[key])
    const selectedSum = selectedSections.reduce(
      (sum, section) => sections.find(item => item.name === section).count + sum,
      0
    )
    const selectedPack =
      selectedSum > 6 && selectedSum <= 11 ? PACKS[1].title : selectedSum > 11 ? PACKS[2].title : PACKS[0].title
    return (
      <div className={cn('App', {App_mobile: isMobile})}>
        <Header isLoaded={isLoaded} />
        <main>
          <Banner isLoaded={isLoaded} width={width} />
          <Mission width={width} />
          <Services width={width} />
          <Benefits width={width} />
          <Packs
            width={width}
            sections={sections}
            sectionsState={this.state}
            selectedPack={selectedPack}
            onSectionSet={this.handleSectionSet}
          />
          <Extras />
          <Portfolio width={width} />
          {/*<Faq />*/}
          <Agency />
        </main>
        <Contact selectedPack={selectedPack} />
        <Messenger />
      </div>
    )
  }
}

export default withWidth()(App)
